import { inject } from '@angular/core';
import { RedirectCommand, ResolveFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { SessionStatusEnum } from 'src/app/@data-services/event-agenda/event-agenda.data-model';
import { EventAgendaDataService } from 'src/app/@data-services/event-agenda/event-agenda.data-service';
import { EventConfigStateService } from 'src/app/@store/event-config-state.service';

// TODO: @later Upgrade checklist item: Update usages of Resolve interface to include RedirectCommand in its return type.
export const determineSessionStatusResolver: ResolveFn<boolean> = (
  route,
  _state
) => {
  if (route.queryParamMap.get('internal')) {
    return true;
  }

  const router = inject(Router);
  const eventAgendaDataService = inject(EventAgendaDataService);
  const eventConfigStateService = inject(EventConfigStateService);

  const isPrimaryScreenParam = route.queryParamMap.get('isPrimaryScreen');
  if (isPrimaryScreenParam !== null) {
    eventConfigStateService.setPrimaryScreen(isPrimaryScreenParam === 'true');
  }

  return eventAgendaDataService
    .getEventDetails({
      event: eventConfigStateService.$eventIdentifier(),
    })
    .pipe(
      map((response) => {
        const sessionId = route.paramMap.get('sessionId') ?? '';
        const selectedSession = response.data.find(
          (e) => e.PrimarySessionId === sessionId
        );
        if (
          selectedSession?.Status === SessionStatusEnum.UnderReview ||
          selectedSession?.Status === SessionStatusEnum.ReviewComplete ||
          selectedSession?.Status === SessionStatusEnum.ProcessingInsights
        ) {
          return new RedirectCommand(
            // Carry `internal` so the debrief resolver's escape hatch fires and
            // it can't bounce us straight back to live. Without it, the two
            // resolvers ping-pong (skipLocationChange SPA redirects) while a
            // session's status is in flux during a live→post-live switch —
            // re-firing getEventDetails each hop, never rendering the component,
            // and pegging the (shared) renderer thread. `merge` keeps existing
            // params like isPrimaryScreen / language.
            router.createUrlTree(['session', sessionId, 'debrief'], {
              queryParams: { internal: '1' },
              queryParamsHandling: 'merge',
            }),
            { skipLocationChange: true }
          );
        }
        return true;
      })
    );
};
